/* eslint-disable react/no-danger */
/* eslint-disable no-case-declarations */
import React, { useState, useCallback } from 'react';
import { compose } from 'redux';
import { Accordion } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import * as faqs from './faqs';

import withLayout from '../../../core/components/with-layout';
import Tabs from '../../constants/tabs';
import { config } from '../../../config';

import {
  Container,
  CustomAccordion,
  Button,
  AccordionList,
} from './styles';

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState('');
  const helpPlaybookURL = config.REACT_APP_HELP_PLAYBOOK_URL || 'https://help.playbookux.com/en/collections/2263552-testers';

  const handleClick = useCallback(
    (e, titleProps) => {
      const { index } = titleProps;
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex(newIndex);
    },
    [activeIndex],
  );

  const handleViewMoreBtn = useCallback(
    (key) => {
      switch (key) {
        case 'section0':
          return activeIndex === key ? (
            <a
              href={helpPlaybookURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="button">Help Center</Button>
            </a>
          ) : (
            <Button type="button">View</Button>
          );

        case 'section1':
          return (
            <Link
              to="/download"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="button">View</Button>
            </Link>
          );

        case 'section2':
          return (
            <Link
              to="/download-mobile"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="button">View</Button>
            </Link>
          );

        default:
          return null;
      }
    },
    [helpPlaybookURL, activeIndex],
  );

  return (
    <Container>
      <AccordionList>
        {Object.entries(faqs.titles).map(([key, title]) => (
          <CustomAccordion key={key} styled>
            <Accordion.Title
              active={activeIndex}
              index={key}
              onClick={handleClick}
            >
              <h3>{title}</h3>

              {handleViewMoreBtn(key)}
            </Accordion.Title>

            {key === 'section0' && (
              <Accordion.Content active={activeIndex === key}>
                {faqs.contents.map((content) => (
                  <details>
                    <summary>{content.title}</summary>
                    <div
                      dangerouslySetInnerHTML={{ __html: content.content }}
                    />
                  </details>
                ))}
              </Accordion.Content>
            )}
          </CustomAccordion>
        ))}
      </AccordionList>
    </Container>
  );
};

export default compose(withLayout({ selectedTab: Tabs.FAQS }))(Faqs);
